.container {
  display: flex;
  flex-direction: column;
  padding-top: 16px;
}

.subtitle {
  padding-bottom: 16px;
}

.tuningRow {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.sliderBox {
  padding: 8px;
}
